import { setEditingCollection } from "../../redux/features/appData";
import "./CollectionCardZero.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

type CollectionsCardZeroProps = {};

export const CollectionCardZero = ({}: CollectionsCardZeroProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div
      className="collection-card-zero"
      onClick={() => {
        dispatch(setEditingCollection(null));
        navigate("/create");
      }}>
      <div className="collection-card-zero-header">Create a New Collection</div>

      <div className="collection-card-zero-icon">
        <img className="icon-plus" />
      </div>
    </div>
  );
};
